import { useQuery } from '@tanstack/react-query';
import { apiAxios } from '@/lib/apiAxios';
const fetchSystemPageDesigns = async () => {
    const response = await apiAxios.get('/page-designs');
    return response.data;
};
export const useSystemPageDesigns = () => useQuery({
    queryKey: ['page-designs'],
    queryFn: fetchSystemPageDesigns,
    // System designs ship with the codebase — they can't change at runtime,
    // so we cache aggressively. A redeploy flushes the SPA cache anyway.
    staleTime: Infinity,
});
